import { AuthorizationData } from "../models/authorization-data.model";

/** Check if access token has expired */
export function hasAccessTokenExpired(authorizationData: AuthorizationData) {
  const exp = authorizationData?.access_token_exp;
  return !exp || Math.floor(Date.now() / 1000) >= exp;
}
